import * as React from 'react'
import { Box, Stack, Card, CardContent, TextField, Button } from '@mui/material'
import ReactMarkdown from 'react-markdown'
import { useMutation } from 'react-query'
import {
  chatClaude,
  ChatClaudeDto,
  getChatgpt_Multurn_qa
} from '@/@core/services/app.service'
import { Delete } from 'mdi-material-ui'
import { useTranslation } from 'react-i18next'

const AnalyzeVariants = React.forwardRef(
  (
    props: {
      value: string
      setAnalyzeVariant?: any
      setIsFinish?: any
    },
    ref
  ) => {
    const { t } = useTranslation()
    const [chat, setChat] = React.useState<any[]>([])
    const [search, setSearch] = React.useState('')

    const getChatClaude = useMutation({
      mutationFn: async (data: ChatClaudeDto) => await chatClaude(data),
      onSuccess: (datas: any) => {
        //post返回的结果

        setChat(datas)
      }
    })

    React.useEffect(() => {
      if (props.value || chat.length) {
        const acmg_chpt = document.getElementById('acmg_chpt')

        if (acmg_chpt) {
          const top = acmg_chpt.scrollHeight - acmg_chpt.clientHeight

          // acmg_chpt.scrollTo({
          //   top,
          //   behavior: 'smooth'
          // })
        }
      }
    }, [props, chat])

    if (!props.value) return <Box></Box>

    return (
      <Box maxWidth={'100%'}>
        <Stack
          width={'100%'}
          spacing={2}
          direction={'row'}
          sx={{ padding: '10px 5px' }}
        >
          <Card>
            <CardContent
              sx={{
                pb: 4
              }}
            >
              <ReactMarkdown>{props.value}</ReactMarkdown>

              {chat && chat.length ? (
                <Stack>
                  <ReactMarkdown>
                    {chat
                      .map((item) => {
                        if (item) return item
                        else return '\n'
                      })
                      .join('')}
                  </ReactMarkdown>

                  <Box textAlign={'right'} py={2}>
                    <Button
                      onClick={() => {
                        setChat([])

                        props.setAnalyzeVariant && props.setAnalyzeVariant('')
                      }}
                      variant="contained"
                      endIcon={<Delete />}
                    >
                      {t('clear')}
                    </Button>
                  </Box>
                </Stack>
              ) : (
                ''
              )}

              {/* <Stack
                sx={{
                  // position: 'absolute',
                  // bottom: 0,
                  // bgcolor: 'white',
                  // width: `${0.855 * 1100}px`,
                  // left: '12.5%',
                  // zIndex: 99
                  mt: 4
                }}
              >
                <TextField
                  id="outlined-multiline-static"
                  placeholder={`${t('Please enter text and press Enter')}`}
                  multiline
                  rows={6}
                  onChange={(e) => {
                    setSearch(e.target.value)
                  }}
                  fullWidth
                  onKeyDown={async (e) => {
                    if (e.key === 'Enter') {
                      e.preventDefault()

                      const list = []

                      if (!search) return

                      props.setIsFinish && props.setIsFinish(true)

                      for await (const result of getChatgpt_Multurn_qa(
                        search
                      )) {
                        // //

                        list.push(result.content)

                        //

                        setChat([
                          ...chat,
                          '\n',
                          ...list.map((item) => {
                            if (item) return item
                            else return '\n'
                          })
                        ])

                        // if (result.content) {
                        //   setChat(chat + result.content)
                        // } else setChat(chat + '\n')
                      }

                      props.setIsFinish && props.setIsFinish(false)
                    }
                  }}
                />
              </Stack> */}
            </CardContent>
          </Card>
        </Stack>
      </Box>
    )
  }
)

export default AnalyzeVariants
